import {Component} from '@angular/core';
import { UserService } from '../../../core/services/user.service';

@Component({
  selector: 'administration-icon',
  templateUrl: './layout.administration-icon.component.html',
  styleUrls: ['./layout.administration-icon.component.scss']
})
export class AdministrationIconComponent {
  constructor(public userService:UserService) {
  }

  showAdmin(){
    alert('No implemented yet SHOW ADMIN');
  }
  ngOnInit() {
    
  }
}
